/* PP ENGRAVING

   The engraving text is captured on the product page and travels with the
   order line as properties[Engraving]. It used to be typed into the Comments
   and Special Shipping Instructions box at checkout, which meant it arrived
   attached to the order rather than to the line, and had to be matched back
   to the piece by hand.

   WHY THIS IS A SEPARATE FILE RATHER THAN PART OF pp-hero.js. That file is a
   single IIFE carrying several early returns, the lightbox one included, so
   anything appended to the end of it silently does not run on a page with no
   lightbox. It is also a shared file that other work touches. Nothing here
   edits it.

   THIS FILE DOES NOT TOUCH cta.disabled. pp-hero.js owns that property and
   rewrites it inside paint() on every option click, so a value set here
   would be undone a moment later and the two would fight. Ownership is split
   instead: pp-hero.js keeps .disabled for availability, this file uses
   aria-disabled for the empty-field state, and the actual block happens on
   form submit. A customer who clicks the button anyway gets the field
   focused and the reason spelled out, which is more use than a dead button.

   THE CHOSEN STYLE IS READ FROM THE PICKER, not from a variant lookup. It is
   whichever tile in the Engraving style group carries aria-pressed="true".
   A MutationObserver watches that attribute rather than a click handler,
   because an observer does not depend on running before or after the handler
   already bound in pp-hero.js.

   SWITCHING STYLE RE-CLEANS RATHER THAN CLEARS. Moving from Three Initials
   to Traditional Monogram keeps KMS, because both take three letters.
   Moving from a date to initials strips the digits and leaves the field
   empty, because none of it was ever legal under the new rule. Clearing on
   every change would throw away work the customer had already done.

   THE MONOGRAM IS TYPED IN NAME ORDER, first, middle, last. The engraver
   arranges it, setting the surname initial larger in the center. Asking a
   customer to type it in engraved order instead, FLM, is the surer route to
   a wrong engraving, because almost nobody thinks of their initials that
   way. The text line is labelled Letters to be engraved because it shows the
   letters only; the clasp picture drawn by pp-engrave-preview.js is what
   shows the monogram arranged.

   DATE IS MM.DD.YY, eight characters including the dots, because that is
   how the engravers cut it (10.10.26). The dots are inserted while typing so
   the stored value cannot drift into MM/DD/YY, MM-DD-YY or MMDDYY, any of
   which the engravers would have to query. Every way of typing it works:
   101026, 10/10/26, 10.10.26 and 10-10-26 all land as 10.10.26. A separator
   the customer types after the second or fourth digit is kept (as a dot)
   rather than stripped, because stripping it looked like the key was
   blocked. One typed anywhere else is dropped. Backspacing over a dot
   removes it and does not put it straight back. A four-digit year is
   allowed while typing (10.10.2026) and shortened to 10.10.26 when the
   field loses focus or the form is sent. Cutting the year off at two digits
   while typing would have turned 2026 into 20 without anyone noticing.
   The check on the date is deliberately loose, month 1 to 12 and day 1 to
   31, so 02.31 passes. A query is a better outcome than refusing a date
   somebody meant.

   INITIALS ARE FORCED UPPERCASE. Both fonts engrave uppercase, so accepting
   a lowercase entry only produces an order that has to be queried.

   THE PICTURE IS A SEPARATE FILE. After every repaint this fires a
   ppdh:engrave event on the wrapper with { kind, font, value, ok }, and
   pp-engrave-preview.js draws from that. The last payload is also left on
   the wrapper as __ppdhLast, in case the preview script loads after the
   first paint. Nothing in this file depends on the preview existing. */

(function () {
  var box = document.querySelector('[data-ppdh-engrave]');
  if (!box) return;

  var input = box.querySelector('[data-ppdh-engrave-input]');
  if (!input) return;

  var help = box.querySelector('[data-ppdh-engrave-help]');
  var err  = box.querySelector('[data-ppdh-engrave-err]');
  var prev = box.querySelector('[data-ppdh-engrave-preview]');
  var out  = box.querySelector('[data-ppdh-engrave-out]');

  var root = document.querySelector('[data-ppdh]');
  var form = document.getElementById('ppdh-form');
  var cta  = root ? root.querySelector('[data-ppdh-cta]') : null;

  /* the picker group holding the engraving styles */
  var group = null;
  var groups = root ? root.querySelectorAll('[data-ppdh-opt]') : [];
  for (var i = 0; i < groups.length; i++) {
    if (groups[i].getAttribute('data-ppdh-optname') === 'Engraving style') {
      group = groups[i];
      break;
    }
  }

  var RULES = {
    single: {
      max: 1,
      hint: 'A',
      help: 'One initial. It is engraved as a capital.'
    },
    three: {
      max: 3,
      hint: 'ABC',
      help: 'Three initials, in the order they should read.'
    },
    monogram: {
      max: 3,
      hint: 'ABC',
      help: 'Three initials in name order: first, middle, last. The surname initial is engraved larger in the center.'
    },
    date: {
      max: 10,
      hint: 'MM.DD.YY',
      help: 'A date, entered as MM.DD.YY. It is engraved with dots, like 10.10.26.'
    }
  };

  var kind = 'single';

  function styleName() {
    if (!group) return '';
    var on = group.querySelector('[aria-pressed="true"]');
    return on ? (on.getAttribute('data-ppdh-val') || '') : '';
  }

  function kindOf(name) {
    var n = String(name).toLowerCase();
    if (n.indexOf('traditional monogram') > -1) return 'monogram';
    if (n.indexOf('three initials') > -1) return 'three';
    if (n.indexOf('date') > -1) return 'date';
    return 'single';
  }

  function cleanLetters(s, max) {
    return String(s).replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, max);
  }

  function cleanDate(s) {
    var raw = String(s);
    var d = raw.replace(/[^0-9]/g, '').slice(0, 8);
    var out = d.slice(0, 2);
    if (d.length > 2) out += '.' + d.slice(2, 4);
    if (d.length > 4) out += '.' + d.slice(4);
    /* keep a separator the customer typed at a legal position (after MM or
       DD) so the key does not look dead; never add one on deletion */
    if (/[.\/\-]$/.test(raw) && (d.length === 2 || d.length === 4)) out += '.';
    return out;
  }

  /* 10.10.2026 becomes 10.10.26. Run on blur and before submit only. */
  function shortYear() {
    if (kind !== 'date') return;
    var v = input.value;
    if (/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/.test(v)) input.value = v.slice(0, 6) + v.slice(8);
  }

  function clean(s) {
    return kind === 'date' ? cleanDate(s) : cleanLetters(s, RULES[kind].max);
  }

  /* Empty string means the entry is good to send. */
  function problem() {
    var v = input.value;
    if (!v) return 'Please add your engraving before adding this to the cart.';

    if (kind === 'date') {
      if (!/^[0-9]{2}\.[0-9]{2}\.[0-9]{2}$/.test(v)) return 'Please enter the date as MM.DD.YY, for example 10.10.26.';
      var mm = parseInt(v.slice(0, 2), 10);
      var dd = parseInt(v.slice(3, 5), 10);
      if (mm < 1 || mm > 12) return 'That month does not look right. Please use MM.DD.YY.';
      if (dd < 1 || dd > 31) return 'That day does not look right. Please use MM.DD.YY.';
      return '';
    }

    if (v.length < RULES[kind].max) {
      return RULES[kind].max === 1 ? 'Please enter one initial.' : 'Please enter all three initials.';
    }
    return '';
  }

  function paint(showError) {
    var rule = RULES[kind];
    var why = problem();
    var ok = why === '';

    input.setAttribute('maxlength', String(rule.max));
    input.setAttribute('placeholder', rule.hint);
    /* decimal, not numeric: the iPhone numeric pad has no dot key */
    input.setAttribute('inputmode', kind === 'date' ? 'decimal' : 'text');
    if (help) help.textContent = rule.help;

    if (out) out.textContent = input.value;
    if (prev) prev.hidden = !ok;

    var detail = {
      kind: kind,
      font: /script/i.test(styleName()) ? 'script' : 'classic',
      value: input.value,
      ok: ok
    };
    box.__ppdhLast = detail;
    try {
      box.dispatchEvent(new CustomEvent('ppdh:engrave', { detail: detail }));
    } catch (e) {}

    if (err) {
      if (showError && !ok) {
        err.textContent = why;
        err.hidden = false;
      } else {
        err.hidden = true;
      }
    }

    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    box.classList.toggle('is-incomplete', !ok);

    /* aria-disabled, never .disabled. See the note at the top. */
    if (cta) {
      cta.setAttribute('aria-disabled', ok ? 'false' : 'true');
      cta.classList.toggle('is-waiting', !ok);
    }
  }

  function syncStyle() {
    var next = kindOf(styleName());
    if (next !== kind) {
      kind = next;
      input.value = clean(input.value);
    }
    /* repaint even when only the font changed, so the preview follows */
    paint(false);
  }

  input.addEventListener('input', function () {
    var at = input.selectionStart;
    var before = input.value;
    var after = clean(before);
    input.value = after;
    if (after === before && at !== null) {
      try { input.setSelectionRange(at, at); } catch (e) {}
    }
    paint(false);
  });

  input.addEventListener('blur', function () { shortYear(); paint(true); });

  if (group) {
    if (window.MutationObserver) {
      new MutationObserver(syncStyle).observe(group, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-pressed']
      });
    }
    group.addEventListener('click', function () { setTimeout(syncStyle, 0); });
  }

  function stop(e) {
    shortYear();
    if (problem() === '') { paint(false); return; }
    e.preventDefault();
    paint(true);
    try { input.focus({ preventScroll: true }); } catch (x) { try { input.focus(); } catch (y) {} }
    if (box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  if (form) form.addEventListener('submit', stop);
  if (cta) cta.addEventListener('click', stop);

  kind = kindOf(styleName());
  paint(false);
})();
